import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import {toast} from "react-toastify";
import {v4 as uuidV4} from "uuid";
import numeric from "../../utils/NumericFunction";
import {validateFormObject} from "./validateForm";
import {current} from "@reduxjs/toolkit";
import numericFunction from "../../utils/NumericFunction";
import {ROW_TYPE} from "./constant";
import utilsFunction from "../../utils/utilsFunction";


export const getData = async ({
                                holder_id, holder_urlId, holder_primaryKey, holder_myLocation,
                              }) => {


  // سه جا داریم که این آی دی میاد
  // اول  پراپس
  // دوم از طریق آدرس که در اینجا
  // urlId
  // سوم
  // در صورتی که فرم روی حالت ویرایش باز میشه
  // اول باید
  // primaryKey
  //   و  اگه خالی بود  باید توی لوکیشن استیت رو نگاه کنیم
  // و از اونجا هم آی دی و هم مقدار ویرایش رو بگیریم
  // از لوکیشن استیت آیدی رو میگیرم

  let myId, myMode = "insert", EditValue;

  if (holder_id || (holder_myLocation.state && holder_myLocation.state.id) || holder_urlId) {
    myId = holder_id || holder_myLocation.state?.id || holder_urlId;
    myMode = holder_primaryKey || (holder_myLocation.state && holder_primaryKey) ? "edit" : "insert";
    EditValue = myMode === "edit" ? (holder_primaryKey || holder_myLocation.state?.primaryKey) : undefined;
  } else {
    toast.error('داده ای برای ارسال اطلاعات موجود نیست!')
    return;
  }


  try {

    const params = {id: holder_id, state: myMode, pkValue: holder_primaryKey}
    const url = prefixUrl() + '/get-form-2/'

    const res = await _axios.get(url, {params})

    if (res.data && typeof (res.data) === "object") {
      return res.data[0]
    } else {
      return {
        formConfig: [{"title": "داده ی معتبری از سرور دریافت نشد."}]
      }
    }
  } catch (error) {
    return {
      formConfig: [{
        "title": " خطا: .\n\n\n   " + JSON.stringify(error),
      }]
    }
  }
}


export const filterFormConfigByHiddenValue = ({formArray, hidden}) => {

  if (hidden.length === 0) {
    return formArray
  }
  let myFormArray = [...formArray]

  hidden.forEach((row, index) => {
    const hiddenId = row.id;

    const dependency = row.dependency;
//مرحله اول:  روی آرایه ی دیپندنسی  حلقه بزن
    dependency.forEach((depRow, depIndex) => {
      // مرحله دوم: به ازای هر حلقه ای که میزنی یه دور روی آرایه ی  فرم ها حلقه بزن

      myFormArray.forEach(formRow => {
        // اگه آیدی  این دیپیندنسی به آیدی اون فرم  یکی بود پنهانش کن
        if (formRow.id === depRow.id) {
          formRow.visible = false
        }
      })
    })
  })


  //// حالا یه دور دیگه حلقه بزن و  درصورتی که موارد دیپندنسی انتخاب شده بود
  // بیا اونو نشون بده
  hidden.forEach((row, index) => {
    const hiddenId = row.id;
    // حالا برو توی دیپندنسی  حلقه بزن

    let selectedValueForSelectOption = myFormArray.filter(v => v.id === hiddenId)[0]['value']

    if (selectedValueForSelectOption) {
      const dependency = row.dependency;
      dependency.forEach((depRow, depIndex) => {
        // حالا نگاه کن  مقدار ولیویی که برای اون آیدی  هست کدومو انتخاب کرده؟

        if (depRow.value === selectedValueForSelectOption) {
          let depRowIdMustShow = depRow.id

          myFormArray.forEach(formArrayRow => {
            if (formArrayRow.id === depRowIdMustShow) {
              formArrayRow.visible = true
            }
          })
        }
      })
    }

  })


  //// حالا یه دور دیگه حلقه بزن و   و مواردی که   پنهان بود مقدار ولیو رو خالی کن
  hidden.forEach((row, index) => {
    const hiddenId = row.id;
    // حالا برو توی دیپندنسی  حلقه بزن

    let selectedValueForSelectOption = myFormArray.filter(v => v.id === hiddenId)[0]['value']

    if (selectedValueForSelectOption) {
      const dependency = row.dependency;
      dependency.forEach((depRow, depIndex) => {
        // حالا نگاه کن  مقدار ولیویی که برای اون آیدی  هست کدومو انتخاب کرده؟
        if (depRow.value !== selectedValueForSelectOption && !depRow.visible) {
          myFormArray.forEach(formArrayRow => {
            if (formArrayRow.id === depRow.id ) {
              formArrayRow.value = '';
              formArrayRow.buttonCaption = 'انتخاب';
            }
          })
          // myFormArray.forEach(formArrayRow => {
          //   if (formArrayRow.id !== depRowIdMustShow && depRow.id===formArrayRow.id ) {
          //     formArrayRow.value = ''
          //   }
          // })
        }
      })
    }

  })

  return myFormArray


}

const serializeForm = (formRef) => {
  const formData = {};
  const formElements = formRef.current.elements;

  for (let i = 0; i < formElements.length; i++) {
    const element = formElements[i];

    if (element.name) {
      if (element.type === 'select-one') {
        formData[element.name] = element.value;
      } else if (element.type === 'checkbox') {
        formData[element.name] = element.checked;
      } else {
        formData[element.name] = element.value;
      }
    }
  }

  return formData;
};

const serializeData = (arr: []) => {
  const myArray = [...arr]
  const newObject = {};
  myArray.forEach(row => {

    if(row.type==='editor'){
      row.value = row.value.replaceAll('&nbsp;' , ' ')
      row.value = utilsFunction.removeSemicolon(row.value)

    }
    newObject[row.name] = row.value

  })

  // اگخ فرمم پرایماری کی نداشت بهش اضافه کن  اینو بک لازم داره تا بفهمه فرم روی ویرایش هست یا روی حالت ادد
  if (!newObject['primaryKey']) newObject['primaryKey'] = ''
  return newObject


}

const dependOnRLookUpFinder = ({formConfig, row}) => {

  const rowName = row?.name;
  let isDepend = false


  for (let i = 0; i < formConfig.length; i++) {
    const row = formConfig[i]
    if (row?.conditionFields !== '') {

      const conditionFieldsArray = row['conditionFields']?.split(',')
      if (conditionFieldsArray.includes(rowName)) {
        isDepend = true;
        break
      }
    }
  }
  return isDepend
}

const resetForm = ({myData}) => {
  // فقط اگر nextBtn فعال بود، reset انجام شود
  if (myData.nextBtn !== "1") {
    return myData.formConfig; // بدون تغییر
  }

  // فقط مقدار فیلدهای required را پاک کن
  return myData.formConfig.map(field => {
    let row = {...field};
    if (row.required) {
      row.value = "";
      if (row?.errorMessage) row.errorMessage = "";
      if (row?.rLookUpJoinResponse) row.rLookUpJoinResponse = "";
    }
    return row;
  });
}

// const resetForm = ({myData}) => {

//   const holder = myData.nextBtn === "1"


//   return myData.formConfig.map(v => {


//     // تاریخ
//     // آرلوکاپ
//     // سلکت بمونه
//     // توضیحات بمونه
//     //number

//     const row = {...v}

//     if (holder) {
//       const holdValue = row.type === ROW_TYPE.TIME || row.type === ROW_TYPE.DATE || row.type === ROW_TYPE.NUMBER || row.type === ROW_TYPE.TEXT_AREA || row.type === ROW_TYPE.SELECT_OPTION || row.type === ROW_TYPE.RLOOKUP
//       // اینجا گویا یه استثنا داریم  و اونم اینه که اگه آرلوکاپ میخواد بمونه باید اون فیلد هایی که بهشون پاسخ داده هم بمونه
//       // یه سری فیلد ممکنه هیدن باشن و توی جواب آرلوکاپ پر شده باشن و نوعش ممهم نیست باید بمونه مقدارش.

//       const isRowDependOnRLookUp = dependOnRLookUpFinder({formConfig: myData.formConfig, row})

//       if (!holdValue || !isRowDependOnRLookUp) {
//         row.value = ''
//         if (row?.rLookUpJoinResponse) {
//           row.rLookUpJoinResponse = ''
//         }
//         if (row?.errorMessage) {
//           row.errorMessage = ''
//         }
//       }
//     }


//     return row
//   })


// }

const sendForm = async ({sendFormArray, myData, setMyData, ref,}) => {


  try {

    let newForm = serializeData(sendFormArray)


    // این مدل دیتایی هست که بک اند میخواد و منم اطلاعات رو توی همون فرمت در آوردم
    const data = `data=${JSON.stringify({

      entities: [{
        entity: myData?.entity || 'ERROR', // Form Entity
        data: [{...newForm}]
      }]
    })}`


    const url = prefixUrl() + `/frm_submit/`;
    const params = {kmo: localStorage.getItem("kmo")}


    const res = await _axios.post(url, data, {params})


    if (res.data.status) {
      toast.success(res.data.message);
      const reload = uuidV4()

      const formConfig = resetForm({myData})
      setMyData({formConfig, reload, mode: 'sent'})
    } else {
      toast.error(res.data.message)
      setMyData({mode: 'sent'})

    }

  } catch (error) {
    setMyData({mode: 'sent'})
  }


}


// بیا یه حالتی رو در نظر بگیریم
// فرض کنیم  این فایل های آپلودی وابسته به یک سلکت آپشن باشن
// پس باید  قبل از اینکه  بررسی کنیم که آیا فایل های آپلود اجباری هستند یا نه
// باید چک کنیم که آیا  اصلا ویزیبل  ترو هست یا نه
// و بعدش اجباری بودنش رو چک کنیم.
const isThereAnyThingToUpload = (array: []) => array.some(row => row.visible && row.type === 'file')
const uploadFiles = async (formObject) => {


  // خروجی این تابع چیه؟
  //  استاتوس درست ینی باید بری توی آرایه ی فایل آدرس رو نگاه کنی
  // استاتوسغلط ینی باید بعدا ارور رو نشون بدی

  const returnObject = {
    status: true, filesAddress: [], message: "",
  }

  // برای آپلود کردن فایل ها باید اول ببینیم آیا آبجکتی که برای فایل هست مقدارش استرینگ هست  یا مقدارش از نوع فایل هست
  // اگه از نوع استرینگ بود ینی روی حالت ویرایش هستیم و نباید آپلود کنیم.

  const myFormData = new FormData();
  let hasAppendedData = true;

  formObject.forEach(row => {

    // Must check typeof row.value==='object'    it means it is not on edit.
    // in edit mode it is a string


    if (row.visible && row.type === 'file' && (typeof row.value === 'object')) {

      myFormData.append(row.name, row.value)
      hasAppendedData = true
    }

  })


  if (hasAppendedData) {
    try {
      const url = prefixUrl() + '/upload/'
      const res = await _axios.post(url, myFormData)
      return res.data

    } catch (error) {
      return {status: false}
    }
  }
  return returnObject
}

const changeFormObjectAfterUploadFiles = (formArray: [], uploadedFilesArray: []) => {

  const temp = [...formArray]
  // فرمت دیتایی که بک اند میفرسته این شکلیه
  //   [
  //   {"na_326": "Morakhasi/92491430.jpg"},
  //  ]
  // ینی یک آرایه از ابجکت هایی که فقط یک کلید دارن و اون کلید نام همون اینپوتی هست که باید آدرس جایگزین فایل بشه و بعدش ارسال بشه

  uploadedFilesArray.forEach(row => {

    const name = Object.keys(row)[0];
    const value = Object.values(row)[0];

    //  اینجا توی آبجگت فرم  چک میکنم و اگه نام برابر با نام کلید فایل آپلودی بود
    // مقدار ولیو رو از مقدار فایل عوض میکنیم و آدرس قرار میدیم.
    temp.forEach(v => {
      if (v.name === name) {
        v.value = value
      }
    })

  })
  return temp
}

export const formSubmitHandler = async ({myData, setMyData, ref}) => {
  const {
    myData: form,
    setMyData: setForm,
    holder_id: id,
    holder_urlId: urlId,
    holder_primaryKey: primaryKey,
    holder_myLocation: myLocation
  } = myData

  // اول باید کل فرم رو چک کنیم
  // بصوص اگه فایل آپلودی اجباری بود و چیزی آپلود نکرده بود باید ارور بدیم.
  // چک فرم باید   تغییراتی که میخواد توی فرم بده رو بگخ. در  واقع باید  یا یک آرایه ی خالی بده یا
  // آرایه ی جدید که میخواد جایگزین قبلی بشه و بگه شرمنده فرم  چک شد ولی  اونی که میخواستم نبود

  console.log(myData.filteredFormConfig)
  const validate = validateFormObject(myData.filteredFormConfig)
  if (!validate.status) {
    setMyData({formConfig: validate.formConfig})
    return
  }

  {


    // const newFormAfter = serializeForm(ref)


    //اگه فایل آپلودی  داشتیم اول باید فایل ها رئ آپلود کنیم  و بعدش فرم رو بفرستیم
    // اگه فایل آپلودی نداشتیم هم  فقط فرم رو میفرستیم
    setMyData({mode: 'sending'})
    if (isThereAnyThingToUpload(myData.filteredFormConfig)) {


      // برای آپلود کردن فایل ها باید اول ببینیم آیا آبجکتی که برای فایل هست مقدارش استرینگ هست  یا مقدارش از نوع فایل هست
      // اگه از نوع استرینگ بود ینی روی حالت ویرایش هستیم و نباید آپلود کنیم.
      // ولی اگه نوعش فایلی بود باید آپلودش کنیم.
      // اگه هم اجباری بود و آپلود نشده بود. ینی ما باید کلا ارور بدیم.
      // چون قبل از این  فرم ولیدشن شده و اصلا نباید حالتی داشته باشیم که اجباری باشه و آپلود نشده باشه
      //

      try {
        const toastId = toast.loading('در حال بارگزاری فایل...')
        const res = await uploadFiles(myData.filteredFormConfig);
        toast.dismiss(toastId)

        if (res.status) {
          const newFilteredFormConfig = changeFormObjectAfterUploadFiles(myData.filteredFormConfig, res.filesAddress);

          void sendForm({sendFormArray: newFilteredFormConfig, myData, setMyData, ref})
        } else {
          toast.error(res.message)
          setMyData({mode: 'sent'})
        }


      } catch (error) {
        setMyData({mode: 'sent'})
      }

    } else {
      void sendForm({sendFormArray: myData.filteredFormConfig, ref, myData, setMyData,})
    }


  }

}

export const replacerLookUpResponseObjectInToFormConfig = (formConfig: [], response: {}) => {

  // const joinResponse = Object.values(response).join(' ')
  for (let key in response) {
    let value = response[key];
    formConfig.forEach(row => {
      if (row['name'] === key) {
        row['value'] = value;
        // این خط اجباری نیست ولی تا وقتی بک اند تغییراتش رو بده کمک میکنه تمامی مقادیر بازگشتی از بک رو کاربر
        // توی فرانت ببینه
        // به همه ی آبجکت هایی که اون کلید رو دارن میچسبه و  نمایش داده میشه
        // معمولا فقط یکیش مقدار ویزیبل ترو هست
        // row['rLookUpJoinResponse'] = numeric.e2p(joinResponse)
      }
    })
  }
  return formConfig
}

export const findOutFormMode = (object) => {
  // میخوایم تشخیص بدیم که فرمی که الان بک فرستاده روی حالت ادیت هست یا روی حالت ادد
  // خب بک گفته من اگه مقدر پرایمری کی رو ست کرده بودم ینی فرم داره ادیت میشه


  // البته خودمم دارم مقدار پرایمری کی رو از پراپز میخونم. اما بهتره که از روی دیتای بک اند تشخیض بدم که فرم ادیت هست یا ادد
  let formMode = 'add'
  object?.formConfig?.forEach(row => {
    if (row["name"] === 'primaryKey' && row["value"] !== '') {
      formMode = 'edit'
    }
  })
  return formMode
}
export const handleCurrentDateTime = ({formConfig}) => {
  const myFormConfig = [...formConfig]

  let today = new Date();
  const options = {
    year: "numeric", month: "2-digit", day: "2-digit", calendar: "persian",
  };
  const currentDate = numericFunction.p2e(today.toLocaleDateString("fa-IR", options));
  const currentTime = ("0" + today.getHours()).slice(-2) + ":" + ("0" + today.getMinutes()).slice(-2) + ":" + ("0" + today.getSeconds()).slice(-2);


  myFormConfig.forEach(row => {
    (row.type === ROW_TYPE.DATE) && (row.value = currentDate);
    (row.type === ROW_TYPE.TIME) && (row.value = currentTime);
  })


  return myFormConfig
}

export const configVariablesIfRLookUp = ({row,myData}) => {
  let variables = {};
  if (!!row['conditionFields']) {
    row['conditionFields'].split(',').forEach(name => {
      myData.formConfig.forEach(row => {
        if (row['name'] === name) {
          variables[name] = row['value']
        }
      })
    })
  }
  return (variables)
}
export const addWidthToTextArea = (row) => {

  if (process.env.REACT_APP_SHOULD_I_EXPAND_OBJ49 === "yes" && row.type === ROW_TYPE.EDITOR) {
    return '100%'
  }

  return undefined

}